import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const Logo = ({
    image,
    classOption = "text-center",
    classImg,
    link = "/",
    target = "",
    alt,
}) => {
    return (
        <Link
            className={`${classOption}`}
            to={process.env.PUBLIC_URL + link}
            target={target}
        >
            <img
                className={`${classImg}`}
                src={process.env.PUBLIC_URL + image}
                alt={alt}
            />
        </Link>
    );
};

Logo.propTypes = {
    image: PropTypes.string,
    classOption: PropTypes.string,
    classImg: PropTypes.string,
    link: PropTypes.string,
    target: PropTypes.string,
    alt: PropTypes.string,
};

export default Logo;
